import React, { useEffect, useState } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { baseListReports } from "../global/reportApiController";
import Loader from "../../global/loader/Loader";
import { fetchHotelEmployee } from "../global/commonNetworkController";
import { BASE_URL, EXCELEXTENSION, formatDateInReact, formatDateInSnp, HotelRoomCateogory, PDFEXTENSION, printDebugLog, REPORT_BASE_URL, ReportFilter, SUCCESS } from "../../constants/Constants";
import { ADMINRIGHTS } from "../../constants/Permissions";
import axios from "axios";



const ReportManagement = () => {

    const todayFormattedDate = new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });


    const INITIAL_REPORTDATA = {
        toDate: todayFormattedDate,
        fromDate: "",
        billType: HotelRoomCateogory.HOTEL_BOTH,
        empIds: [],
        listBillStatus: [],
        isGstAllowed: true,
    };

    const BILL_STATUS = [
        { id: 0, name: "In Estimation" },
        { id: 3, name: "Room alloted but not paid" },
        { id: 4, name: "Room alloted and paid" },
        { id: 5, name: "Room alloted and paid but restaurant bill not paid" },
        { id: 6, name: "Room alloted but partially paid" },
        { id: 7, name: "Full settled" },
        { id: 8, name: "Settled but in dues" },
        { id: 9, name: "Booking Cancelled" },
    ]


    const navigate = useNavigate();
    const { activeShopHash, authUser, isRoleAllowed } = useAuth();


    const [listReports, setListReports] = useState([]);
    const [listEmployee, setListEmployee] = useState([]);


    const [loader, setLoader] = useState(false);
    const [singleColumn, setSingleColumn] = useState(null);
    const [reportData, setReportData] = useState(INITIAL_REPORTDATA);

    useEffect(() => {
        fetchListReports();
    }, []);

    const fetchListReports = async () => {
        setLoader(true);
        await baseListReports({
            authUser: authUser,
            activeShopHash: activeShopHash,
            onResponseCallback: (payload) => {
                setLoader(false);
                if (payload !== null) {
                    setListReports(payload.fullData);
                }
            }
        })
    };

    const getHotelEmployees = async () => {
        await fetchHotelEmployee({
            authUser: authUser,
            activeShopHash: activeShopHash,
            setLoader: setLoader,
            onResponseCallback: (payload) => {
                if (payload !== null) {
                    setListEmployee(payload?.data ?? []);
                } else {
                    setListEmployee([]);
                }
            }
        })
    };

    const buildReport = async (type) => {
        try {
            setLoader(true);
            const empIdList = reportData.empIds
                .map(emp => emp?.empId)
                .filter(Boolean);
            const listBillStatus = reportData.listBillStatus
                .map(emp => emp?.id)
                .filter(Boolean);
            const mUrl = `${REPORT_BASE_URL}${singleColumn.baseUrl}`;
            const filledData = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    type: type,
                    empIds: empIdList,
                    listBillStatus: listBillStatus,
                    billType: reportData.billType,
                    isGstAllowed: reportData.isGstAllowed,
                    fromDate: reportData.fromDate,
                    toDate: reportData.toDate,
                }
            }
            const response = await axios.post(mUrl, filledData);
            if (response.data.status === SUCCESS) {
                const url = BASE_URL + "/files/" + response.data.payLoad.path;
                window.open(url, '_blank');
            }
        } catch (error) {
            console.error(`buildReport ${type}`, error);
        } finally {
            setLoader(false);
        }
    }

    const isFilterAvailable = (targetFilter, filter) => {
        if (filter.length === 0) {
            return false;
        }
        const index = filter.indexOf(targetFilter);
        //printLog("isFilterAvailable", index , targetFilter , filter);
        return (index !== -1);
    };

    const updateUi = (e, data) => {
        setSingleColumn(data);
        if (data !== null) {
            if (isFilterAvailable(ReportFilter.EMPLOYEE, data.filter)) {
                getHotelEmployees();
            }
        }
    }

    const handleSelectEmployee = (event, newValue, reason, detail) => {
        printDebugLog("handleSelectEmployee", event.key, newValue, reason, detail);
        if (reason === 'removeOption') {
            setReportData(prev => ({
                ...prev,
                empIds: prev.empIds.filter(i => i.empId !== detail?.option?.empId),
            }));
        } else if (reason === 'selectOption' || reason === 'createOption') {
            setReportData((prev) => ({
                ...prev,
                empIds: newValue,
            }));
        } else if (reason === 'clear') {
            setReportData((prev) => ({
                ...prev,
                empIds: [],
            }));
        }
    };

    const handleBillStatus = (event, newValue, reason, detail) => {
        printDebugLog("handleBillStatus", event.key, newValue, reason, detail);
        if (reason === 'removeOption') {
            setReportData(prev => ({
                ...prev,
                listBillStatus: prev.listBillStatus.filter(i => i.id !== detail?.option?.id),
            }));
        } else if (reason === 'selectOption' || reason === 'createOption') {
            setReportData((prev) => ({
                ...prev,
                listBillStatus: newValue,
            }));
        } else if (reason === 'clear') {
            setReportData((prev) => ({
                ...prev,
                listBillStatus: [],
            }));
        }
    };


    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {
                        loader && <Loader />
                    }
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 2,
                            p: 2,
                            backgroundColor: "#f5f5dc",
                        }}>
                        <Grid container spacing={1}>
                            <Grid item md={8} sm={8} lg={8} xs={12}>
                                <Autocomplete
                                    id="select-label"
                                    variant="filled"
                                    size="small"
                                    autoHighlight
                                    options={listReports}
                                    onChange={updateUi}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => option?.baseUrl === value?.baseUrl}
                                    value={singleColumn}
                                    renderOption={(props, option) => (
                                        <Box
                                            key={option?.baseUrl ?? ""}
                                            component="li"
                                            {...props}
                                        >
                                            {option.name}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Report Type"
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                />
                            </Grid>
                            {
                                isFilterAvailable(ReportFilter.DATE_FILTER, singleColumn?.filter ?? []) &&
                                <Grid item xs={12}>
                                    <Grid container spacing={1} sx={{
                                        padding: 0,
                                    }}>
                                        <Grid item xs={12}>
                                            <center>
                                                <Typography variant="h5"
                                                    component="div"
                                                    style={{ color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                                                    Select Start and End Date (End Date is mandatory*)
                                                </Typography>
                                            </center>
                                        </Grid>
                                        <Grid item md={6} xs={12} sm={6}>
                                            <TextField
                                                id="fromDate"
                                                name="fromDate"
                                                variant="filled"
                                                size="small"
                                                label="Enter Start Date"
                                                value={formatDateInReact(reportData.fromDate)}
                                                onChange={(e) => {
                                                    const formatDateVal = formatDateInSnp(e.target.value, "");
                                                    setReportData(prev => ({
                                                        ...prev, fromDate: formatDateVal
                                                    }));
                                                }}
                                                fullWidth
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    inputProps: {
                                                        min: '2000-01-01',
                                                        max: formatDateInReact(todayFormattedDate),
                                                    },
                                                }} />

                                        </Grid>
                                        <Grid item md={6} xs={12} sm={6}>
                                            <TextField
                                                id="toDate"
                                                name="toDate"
                                                variant="filled"
                                                size="small"
                                                label="Enter End Date"
                                                required
                                                value={formatDateInReact(reportData.toDate)}
                                                onChange={(e) => {
                                                    const formatDateVal = formatDateInSnp(e.target.value, "");
                                                    setReportData(prev => ({
                                                        ...prev, toDate: formatDateVal
                                                    }));
                                                }}
                                                fullWidth
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }} />
                                        </Grid>

                                    </Grid>
                                </Grid>
                            }
                            {
                                (isFilterAvailable(ReportFilter.EMPLOYEE, singleColumn?.filter ?? []) && isRoleAllowed(ADMINRIGHTS)) &&
                                <Grid item md={6} sm={6} lg={6} xs={12}>
                                    <Autocomplete id="tags"
                                        multiple
                                        freeSolo
                                        options={listEmployee}
                                        autoHighlight
                                        size="small"
                                        variant="filled"
                                        fullWidth
                                        value={reportData.empIds ?? []}
                                        onChange={handleSelectEmployee}
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        renderOption={(props, option) => (
                                            <Box
                                                key={option?.empId ?? ""}
                                                component="li"
                                                {...props}
                                            >
                                                {option?.name}
                                            </Box>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="empIds"
                                                label="Select Employee"
                                                inputProps={{
                                                    ...params.inputProps,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            }
                            {
                                (isFilterAvailable(ReportFilter.BILL_STATUS, singleColumn?.filter ?? [])) &&
                                <Grid item md={6} sm={6} lg={6} xs={12}>
                                    <Autocomplete id="tags"
                                        multiple
                                        freeSolo
                                        options={BILL_STATUS}
                                        autoHighlight
                                        size="small"
                                        variant="filled"
                                        fullWidth
                                        value={reportData.listBillStatus ?? []}
                                        onChange={handleBillStatus}
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        renderOption={(props, option) => (
                                            <Box
                                                key={option?.id ?? ""}
                                                component="li"
                                                {...props}
                                            >
                                                {option?.name}
                                            </Box>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="listBillStatus"
                                                label="Select Bill Status"
                                                inputProps={{
                                                    ...params.inputProps,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            }
                            {
                                isFilterAvailable(ReportFilter.BILL_TYPE, singleColumn?.filter ?? []) &&
                                <Grid item md={6} xs={12} sm={6}>
                                    <RadioGroup
                                        row
                                        aria-label="type"
                                        name="type"
                                        value={reportData.billType}
                                        onChange={(e) => setReportData(prev => ({
                                            ...prev, billType: Number(e.target.value)
                                        }))}
                                    >
                                        <FormControlLabel
                                            value={HotelRoomCateogory.HOTEL_ROOM}
                                            control={<Radio />}
                                            label="Only Room"
                                        />
                                        <FormControlLabel
                                            value={HotelRoomCateogory.HOTEL_BANKQUET}
                                            control={<Radio />}
                                            label="Only Banquet"
                                        />
                                        <FormControlLabel
                                            value={HotelRoomCateogory.HOTEL_BOTH}
                                            control={<Radio />}
                                            label="Room/Banquet"
                                        />
                                    </RadioGroup>
                                </Grid>
                            }
                            {
                                isFilterAvailable(ReportFilter.GST_FEATURE, singleColumn?.filter ?? []) &&
                                <Grid item xs={12} md={6} lg={6} sm={6}>
                                    <FormControl>
                                        <FormControlLabel name="isGstAllowed" checked={reportData.isGstAllowed}
                                            control={<Checkbox />}
                                            onChange={(e) => setReportData(prev => ({
                                                ...prev, isGstAllowed: !prev.isGstAllowed,
                                            }))} label={reportData.isGstAllowed ? "Enable(Uncheck to disable) GST" : "Disable(Check to enable) GST"} />
                                    </FormControl>
                                </Grid>
                            }
                            {/* Force next line */}
                            <Grid item xs={12} />
                            {
                                (singleColumn && singleColumn?.name !== "Date wise Available Room Report") &&
                                <Grid item xs={12} md={6} sm={6}>
                                    <Button variant="contained" color="primary" onPointerDown={() => buildReport(PDFEXTENSION)}>
                                        Generate Pdf
                                    </Button>
                                </Grid>
                            }
                            {
                                singleColumn &&
                                <Grid item xs={12} md={6} sm={6}>
                                    <Button variant="contained" color="primary" onPointerDown={() => buildReport(EXCELEXTENSION)}>
                                        Generate Excel
                                    </Button>
                                </Grid>
                            }
                            {
                                singleColumn &&
                                <Grid item xs={12} md={6} sm={6}>
                                    <Button variant="contained" sx={{
                                        bgcolor: "#ab3f32",
                                        "&:hover": { bgcolor: "#92342a" },
                                    }} onPointerDown={() => {
                                        setReportData(INITIAL_REPORTDATA);
                                        setSingleColumn(null);
                                    }}>
                                        Clear Selection
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary" onPointerDown={() => navigate("/home")}>
                        Dismiss
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}
export default ReportManagement;